import { h } from 'preact'
import { IMatchData } from '../../lib/model'
import styles from './MatchTeams.module.css'
import { TeamLogo } from '../TeamLogo/TeamLogo'
import { useCustomContext } from '../../lib/context'

interface Props {
  matchData: IMatchData
  openInParent: Boolean
}

export function MatchTeams(props: Props) {
  const context = useCustomContext()
  const handleClick = () => {
    context?.sendGaEvent({ eventAction: 'click', eventLabel: props.matchData.resultLink })
  }
  return (
    <div class={styles['dh-fotball-banner__match-teams-wrapper']}>
      <a
        href={props.matchData.resultLink}
        onClick={handleClick}
        target={props.openInParent ? '_parent' : '_self'}
      >
        <div class={styles['dh-fotball-banner__match-team']}>
          <TeamLogo logoUrl={props.matchData.homeTeam.logoUrl} />
          <div>{props.matchData.homeTeam.name}</div>
        </div>
        <div class={styles['dh-fotball-banner__match-team']}>
          <TeamLogo logoUrl={props.matchData.awayTeam.logoUrl} />
          <div>{props.matchData.awayTeam.name}</div>
        </div>
      </a>
    </div>
  )
}
